import PropTypes from 'prop-types';
import React from 'react';

import { Chip } from '@mui/material';

const statusProperties = {
  CREATED: {
    label: 'Pendiente',
    color: '#3E66FB',
    borderColor: '#3E66FB',
  },
  ACCEPTED: {
    label: 'En curso',
    color: '#FF730C',
    borderColor: '#FF730C',
  },
  COMPLETED: {
    label: 'Creado',
    color: '#12C238',
    borderColor: '#12C238',
  },
  REJECTED: {
    label: 'Rechazada',
    color: 'red',
    borderColor: 'red',
  },
};

export const StatusBadge = ({ status }) => {
  const { label, color, borderColor } = statusProperties[status] || {};
  return (
    <Chip
      label={label ?? '-'}
      variant="outlined"
      style={{ color, borderColor, fontWeight: 500 }}
    />
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOf(['CREATED', 'ACCEPTED', 'COMPLETED', 'REJECTED']).isRequired,
};
